<template>
    <div class="online">
        <div class="people-online" v-if="isOnline"></div>
        <div class="people-offline" v-if="!isOnline && getWasOnline">
            <img src="@/assets/images/icons/time.svg" alt="">
            <p>Был в сети {{ getWasOnline }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Online',
    props: {
        last_activity: {
            type: String,
            require: false
        }
    },
    computed: {
        isOnline() {
            let five_mins_ago = Date.now() - 5 * 60 * 1000;
            let last_ac = new Date(this.last_activity);
            return this.last_activity ? last_ac > five_mins_ago : null
        },
        getWasOnline() {
            return this.last_activity 
            ? this.$moment(this.last_activity).locale('ru').fromNow()
            : null;
        },
    }
}
</script>
<style lang="stylus">
.online
    position absolute
    z-index 2
    left 0
    top 0
    width 100%
    
.people
    &-offline
        position absolute
        left 15px
        top 15px
        opacity 0.2
        display flex
        align-items center
        t()
        p
            margin-left 5px
            font-weight 500
            font-size 12px
            opacity 0
        
        &:hover
            opacity 0.9
            p
                opacity 1
    &-online
        position absolute
        left 20px
        top 20px
        // border 2px solid white
        background-color #51ea08
        width 15px
        height 15px
        border-radius 50%
        &:after
            content ''
            left -6px
            top -6px
            bottom -6px
            right -6px
            border-radius 50%
            position absolute
            background-color #51ea08
            opacity 0.4
            animation pulse 1s alternate infinite
</style>